<template>
  <div class="attrs" :style="'right:' + rightPosition">
    <i class="el-icon-close close"
       @click="closeTree"></i>
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane class="tab1"
                    :label='$t("deviceProperty.property")'
                   name="first">
        <el-button type="primary" size="mini" @click="saveMeterView()"><i class="iconfont icon-icon_shijiao-3"></i>&nbsp;&nbsp;&nbsp;保存视角</el-button>
        <el-collapse v-model="activeNames" v-if="attrDatas">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="custom-add">
                <!-- {{ attrDatas[0].propertySetName }} -->
                {{ $t('deviceProperty.exAttr') }}
              </div>
            </template>
            <div class="custom-attr">
              <span>{{ $t("deviceProperty.attrName") }}</span>
              <span>{{ $t("deviceProperty.attrValue") }}</span>
              <p>
                <el-link v-if="$store.state.perList.includes('19-1')" @click="append()" :underline="false" icon="el-icon-circle-plus-outline"></el-link>
              </p>
            </div>
            <ul class="custom-attr-list" v-if="attrDatas[0].dataList">
              <li @mouseenter="currentIndex = index" @mouseleave="currentIndex = null" v-for="(i, index) in attrDatas[0].dataList" :key="index">
                <span>{{ i.propertyname }}</span>
                <span>{{ i.provalue }}</span>
                <el-link v-if="currentIndex === index && $store.state.perList.includes('19-1')" :underline="false" icon="el-icon-edit" @click="changeAttr(i)"></el-link>
                <el-link v-if="currentIndex === index && $store.state.perList.includes('19-1')" :underline="false" icon="el-icon-delete" @click="delAttr(i)"></el-link>
              </li>
            </ul>
            <div class="no-custom-attr" v-if="!attrDatas[0].dataList">
              {{ $t('deviceProperty.noData') }}
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <div>
                <!-- {{ attrDatas[1].propertySetName }} -->
                {{ $t('deviceProperty.proPar') }}
              </div>
            </template>
            <ul class="normal-attr">
              <li v-for="(i, index) in attrDatas[1].dataList" :key="index">
                <span v-if="i.propertyname !== '位号' && i.propertyname !== '描述'">{{ i.propertyname }}</span>
                <span v-if="i.propertyname !== '位号' && i.propertyname !== '描述'">{{ i.provalue }}</span>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <div v-if="!attrDatas" style="color: #333">
          {{ $t('docMgt.noData') }}
        </div>
      </el-tab-pane>
      <el-tab-pane class="tab3" :label='$t("deviceProperty.info")' name="third">
        <div v-if="hasResult" class="cont">
          <div class="info-list scrollbar">
            <div class="com datas" v-if="info.realData">
              <div class="child-title">
                <span>{{ $t("deviceProperty.realData") }}&nbsp;<i>({{info.realData.length}})</i></span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="data-info" v-for="(i, index) in info.realData" :key="index">
                <div class="info-left">
                  <span @click="selectPos(i, 1)"><i></i>{{i.deviceName}}</span>
                  <b>{{i.tagDes}}</b>
                </div>
                <div class="info-right">
                  <span>{{i.qValue}}{{i.unit}}</span>
                </div>
              </div>
            </div>
            <div class="com datas" v-if="info.bitNumberData">
              <div class="child-title">
                <span>{{ $t("deviceProperty.posData") }}&nbsp;<i>({{info.bitNumberData.length}})</i></span>
                <!-- <i class="el-icon-arrow-right"></i> -->
              </div>
              <div class="data-info" v-for="(i, index) in info.bitNumberData" :key="index">
                <div class="info-left">
                  <span @click="selectPos(i, 2)">{{i.bitNumber}}</span>
                </div>
                <div class="info-right">
                  <span>{{i.name}}</span>
                </div>
              </div>
            </div>
            <div class="com pids" v-if="info.searchPidData">
              <div class="child-title">
                <span>{{$t("deviceProperty.pid") }}&nbsp;<i>({{info.searchPidData.length}})</i></span>
                <!-- <i class="el-icon-arrow-right"></i> -->
              </div>
              <div class="file-info" v-for="(i, index) in info.searchPidData" :key="index">
                <div class="file-top" @click="previewClick(i)">
                  {{i.fileName}}
                </div>
                <div class="file-bottom">
                  <!-- <span>{{i.bitNumber}}</span>
                  <i>{{i.CreateTime | dateFormat('yyyy-M-d hh:mm')}}</i> -->
                  <span>
                    {{ i.name }}
                  </span>
                </div>
              </div>
            </div>
            <div class="com" v-if="info.docData">
              <div class="child-title">
                <span>{{ $t("deviceProperty.docManage") }}&nbsp;<i>({{info.docData.length}})</i></span>
                <!-- <i class="el-icon-arrow-right"></i> -->
              </div>
              <div class="files scrollbar">
                <div class="file-info" v-for="(i, index) in lessDoc" :key="index" @click="fileView(i.fid)">
                  <div class="file-top">
                    <img v-if="fileTypeList.includes(i.fileName.substr(i.fileName.lastIndexOf('.') + 1))" :src="require(`../../assets/images/file/${i.fileName.substr(i.fileName.lastIndexOf('.') + 1)}.png`)" alt="">
                    <img v-else src="../../assets/images/file/no.png" alt="">
                    {{i.fileName}}
                  </div>
                  <!-- <div class="file-bottom">
                    <span>{{i.FID}}</span>
                    <i>{{i.CreateTime | dateFormat('yyyy-M-d hh:mm')}}</i>
                  </div> -->
                </div>
              </div>
              <el-link v-if="showMoreDoc" :underline="false" @click="showMore">展开更多({{ info.docData.length - 2 }})<i class="el-icon-arrow-down el-icon--right"></i></el-link>
            </div>
            <div class="com videos" v-if="info.CCTVData">
              <div class="child-title">
                <span>{{ $t("deviceProperty.video") }}&nbsp;<i>({{info.CCTVData.length}})</i></span>
                <!-- <i class="el-icon-arrow-right"></i> -->
              </div>
              <div class="video-info" v-for="(i, index) in info.CCTVData" :key="index">
                <p>{{i.pType}}</p>
                <span>{{i.typeName}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!hasResult" class="cont">
          <p class="empty-info">
            {{ $t("deviceProperty.noData") }}
          </p>
        </div>
      </el-tab-pane>
      <el-tab-pane class="tab2"
                   :label='$t("deviceProperty.hierarchyModel")'
                   name="second">
        <el-tree class="tree"
                 node-key="id"
                 @node-click="handleNodeClick"
                 @check-change="handleNodeChange"
                 :default-checked-keys="[1238817]"
                 :props="props"
                 :load="loadNode1"
                 lazy
                 show-checkbox>
          <span class="custom-tree-node2"
                slot-scope="{ data }">
            <span>
              <i :class="data.icons"></i>
              {{ data.name}}
            </span>
          </span>
        </el-tree>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import "@/common/css/scrollbar.css";
// import Vue from 'vue'
import { mapState } from 'vuex'
import ApiService from '@/services/API-services'
export default {
  name: 'attrs',
  data() {
    return {
      activeName: 'first',
      activeNames: ['1', '2'],
      expandflag: true,
      defaultProps: {
        children: 'children',
        label: 'label',
        icons: 'icons'
      },
      glid: null,
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      addShow: false,
      hasResult: false,
      info: null,
      fileTypeList: [
        'doc', 'docx', '3gp', 'ai', 'avi', 'bmp', 'dwg', 'dxf', 'eps', 'flv', 'gif', 'jpg', 'mov', 'pptx', 'mpeg2', 'mpeg4', 'pdf', 'png', 'ppt', 'psd', 'rm', 'rmvb', 'svg', 'txt', 'webp', 'wmv', 'word', 'xls', 'xlsx', 'zip', 'jpeg'
      ],
      lessDoc: [],
      showMoreDoc: false,
      attrDatas: null,
      currentIndex: null,
      rightPosition: '0'
    }
  },
  created() {
    this.attrDatas = this.$store.state.attrData
    if (document.getElementById('collect')) {
      this.rightPosition = '300px'
    }
  },
  computed: {
    attrData() {
      return this.$store.state.attrData
    }
  },
  watch: {
    attrData: {
      deep: true,
      handler: function(val) {
        this.attrDatas = val
        this.attrSearch()
      }
    }
  },
  methods: {
    append() {
      this.$store.commit('showModal', { name: 'addattr', show: true, top: '2rem', left: '', data: null})
    },
    changeAttr(i) {
      this.$store.commit('showModal', { name: 'changeattr', show: true, top: '2rem', left: '', data: i})
    },
    saveMeterView() {
      ApiService.doc.setAngel({
        bitNumber: window.Muster,
        angelCode: window.GetView(),
        mileageID: window.R_config.modelId
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: res.msg
          })
        }
      })
    },
    delAttr(i) {
      ApiService.tree.removeExtraProp({ id: i.id }).then(res => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('menu.sccg'),
            type: 'success'
          })
          this.getproperty()
        } else {
          this.$message({
            message: this.$t('menu.sb'),
            type: 'error'
          })
        }
      })
    },
    getproperty() {
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          bitNumber: window.Muster
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
          }
        })
    },
    handleClick(tab, event) {
      // console.log(tab, event)
      if (tab.name == 'third') {
        this.attrSearch()
      }
    },
    fileView(val) {
      ApiService.person_doc.getPersonDoc({
        id: val
      }).then(res => {
        if ( res.data[0].ext.toLowerCase() === 'pdf' || res.data[0].ext.toLowerCase() === 'doc' || res.data[0].ext.toLowerCase() === 'docx' || res.data[0].ext.toLowerCase() === 'rtf' || res.data[0].ext.toLowerCase() === 'xls' || res.data[0].ext.toLowerCase() === 'xlsx' || res.data[0].ext.toLowerCase() === 'ppt' || res.data[0].ext.toLowerCase() === 'pptx' || res.data[0].ext.toLowerCase() === 'txt' || res.data[0].ext.toLowerCase() === 'wps') {
          window.open('../../static/preview.html?fileUrl=' + res.data[0].path)
        } else {
          window.open(res.data[0].path)
        }
        // if (res.data[0].ext === 'Pdf' || res.data[0].ext === 'pdf') {
        //   window.open(res.data[0].path)
        // } else {
        //   window.open('../../static/preview.html?fileUrl=' + res.data[0].path)
        // }
      })
    },
    attrSearch() {
      if (!window.Muster) {
        this.hasResult = false
        return
      }
      ApiService.doc.attrSearch({
        mileageID: window.R_config.modelId,
        bitNumber: window.Muster
      }).then(res => {
        if (res.code === 0) {
          this.info = res.data
          this.hasResult = true
          let a = this.info.realData? this.info.realData.length: 0
          let b = this.info.docData? this.info.docData.length: 0
          let c = this.info.realData? this.info.realData.length: 0
          let d = this.info.bitNumberData? this.info.bitNumberData.length: 0
          // console.log(b)
          this.lessDoc = this.info.docData
          // if (b > 3 && !this.showMoreDoc) {
          //   this.lessDoc = this.info.docData.slice(0, 2)
          //   console.log(this.lessDoc)
          //   this.showMoreDoc = true
          // }
          this.allNumber = a + b + c + d
        } else {
          this.hasResult = false
          this.info = ''
        }
      })
    },
    showMore() {
      this.lessDoc = this.info.docData
      this.showMoreDoc = false
    },
    selectPos(row, val) {
      ApiService.doc
        .getModelData({
          glid: '',
          bitNumber: row.deviceName || row.bitNumber,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          let glids = ''
          if (res.data.glid.length > 1) {
            glids = res.data.glid.join('#')
          } else {
            glids = res.data.glid[0]
          }
          this.addLabel(row, glids, res.data.bitNumber)
          if (val === 1) {
            this.openChart(row)
          }
        })
    },
    openChart(row) {
      row.Type = 1
      this.$store.commit('setEqData', row)
      this.$store.commit('showModal', {
        name: 'eqChart',
        show: true,
        left: '',
        top: '1rem',
        data: null
      })
    },
    previewClick(row) {
      this.$store.commit('closeModal', 'dwglist')
      // this.$store.commit('closeModal', 'dwgpreview')
      setTimeout(() => {
        this.$store.commit('showModal', {
          name: 'dwglist',
          show: true,
          top: '.4rem',
          left: '.6rem',
          data: row
        })
      }, 500)
    },
    addLabel(row, glids, bit) {
      window.ResetAllElement()
      window.elementType = 0
      window.currentElement = glids
      window.FlyTo(glids, true, 2.8)
    },
    closeTree() {
      this.$store.commit('closeModal', 'attrs')
      window.SetClickMode(3)
      window.clickMode = ''
    },
    handleNodeClick(node) {
      if (node.level > 2) {
        ApiService.tree
          .guids({
            mileageID: window.R_config.modelId,
            glid: node.glid || ''
          })
          .then(res => {
            if (res.code == '0') {
              window.FlyTo(res.data[0].column1, true, 2.8)
              window.SetElementColor(res.data[0].column1, 255, 0, 0)
            }
          })
      }
    },
    loadNode1(node, resolve) {
      if (node.level === 0) {
        ApiService.tree
          .first({
            mileageID: window.R_config.modelId
          })
          .then(res => {
            if (res.code == '0') {
              resolve(res.data)
            } else {
              resolve([])
            }
          })
      }
      if (node.level >= 1) {
        ApiService.tree
          .treeson({
            mileageID: window.R_config.modelId,
            level: node.level - 1,
            pGlid: node.data.glid || ''
          })
          .then(res => {
            if (res.code == '0') {
              resolve(res.data)
            } else {
              resolve([])
            }
          })
      }
    },
    handleNodeChange(node, isCheck, child) {
      window.resetView()
      if (node.level > 2) {
        ApiService.tree.guids({
          mileageID: window.R_config.modelId,
          glid: node.glid || ''
        }).then(res => {
          if (res.code == '0') {
            // const d = Date.now()
            // console.log(res)
            // window.FlyTo(res.data[0].Column1, 2.8)
            if (isCheck) {
              window.SetElementColor(res.data[0].column1, 255, 0, 0)
            } else {
              // 单模型恢复
              // window.Set
              window.ResetElement(res.data[0].column1)
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.attrs {
  width: 300px;
  height: calc(100vh - 40px);;
  background-color: #1D2C48;
  font-size: 0.12rem;
  font-family: MicrosoftYaHei;
  right: 0;
  bottom: 0;
  position: fixed;
  top: 40px;
  color: rgba(255, 255, 255, 0.65);
  .close {
    position: absolute;
    right: 10px;
    color: #fff;
    top: 10px;
    font-size: 18px;
    cursor: pointer;
    z-index: 2053;
    opacity: 1;
    &:hover {
      color: #66b1ff;
    }
  }
  .el-tabs {
    background-color: transparent;
    // overflow: auto;
    height: 100%;
    .el-tabs__item.is-active {
      color: #fff;
    }
    .el-tabs__content {
      overflow: auto;
      height: calc(100% - 55px);
      // padding: 0 10px;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .el-tabs__content {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .el-tabs__nav-scroll {
      padding: 0 20px;
    }
    .el-tabs__nav-wrap::after {
      background: rgba(255, 255, 255, 0.1);
    }
    .cont {
      color: #333;
      padding: 0 10px;
      .empty-info {
        color: rgba(255, 255, 255, 0.65);
      }
      .info-title {
        height: 38px;
        line-height: 38px;
        padding: 0 16px;
        font-size: 16px;
        text-align: left;
        border-bottom: 1px solid #e6e6e6;
        i {
          font-size: 14px;
          font-style: normal;
          color: #999;
        }
      }
      .info-list {
        .com {
          .el-link.el-link--default {
            color: #fff;
            font-size: 12px;
          }
          .child-title {
            display: flex;
            justify-content: space-between;
            text-align: left;
            align-items: center;
            color: rgba(255, 255, 255, 0.85);
            span {
              display: block;
              height: 30px;
              line-height: 30px;
              i {
                font-size: 12px;
                font-style: normal;
                color: rgba(255, 255, 255, 0.65);
              }
            }
            i {
              cursor: pointer;
            }
          }
          .data-info {
            padding: 5px 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            &:hover {
              background:  rgba(255, 255, 255, 0.2);
              color: #fff;
            }
            .info-left {
              display: flex;
              flex-direction: column;
              span {
                color: rgba(255, 255, 255, 0.85);
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                  display: block;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background: #8ebd5d;
                  margin-right: 8px;
                }
              }
              b {
                display: block;
                color: rgba(255, 255, 255, 0.65);
                font-size: 12px;
                margin-top: 5px;
              }
            }
            .info-right {
              display: block;
              color: rgba(255, 255, 255, 0.85);
            }
          }
          .file-info {
            padding: 5px 16px;
            
            &:hover {
              background: rgba(255, 255, 255, 0.2);
              color: #fff;
            }
            .file-top {
              text-align: left;
              margin-bottom: 5px;
              cursor: pointer;
              display: flex;
              align-items: center;
              color: rgba(255, 255, 255, 0.65);
              img {
                height: 20px;
                flex-shrink: 0;
                margin-right: 10px;
              }
            }
            .file-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.65);
              span {
                text-align: left;
              }
              span,
              i {
                display: block;
                font-style: normal;
                font-size: 12px;
              }
            }
          }
          .video-info {
            padding: 10px 16px;
            text-align: left;
            p {
              color: #666;
            }
            span {
              display: block;
              margin-top: 5px;
              color: #999;
              font-size: 12px;
            }
            &:hover {
              background: #f4f9fd;
            }
          }
        }
        .files {
          max-height: 550px;
          overflow: auto;

          .child-title {
            display: flex;
            justify-content: space-between;
            text-align: left;
            align-items: center;
            span {
              display: block;
              height: 30px;
              line-height: 30px;
              i {
                font-size: 12px;
                font-style: normal;
                color: #999;
              }
            }
            i {
              cursor: pointer;
            }
          }
        }
      }
    }
    .el-tabs__item {
      color: rgba(101,117,143,1.00);
    }
    .tab1 {
      .el-button {
        display: flex;
        margin-left: 20px;
      }
      .el-collapse {
        background: transparent;
        border: 0;
        .el-collapse-item__wrap {
          background: transparent;
          border-color: rgba(255, 255, 255, 0.15);
        }
        .el-collapse-item__header {
          line-height: 30px;
          height: 30px;
          color: rgba(255, 255, 255, 0.85);
          padding: 0 10px;
          background: transparent;
          border-color: rgba(255, 255, 255, 0.15);
          .custom-add {
            color: #fff;
          }
        }
        .el-collapse-item__content {
          padding-bottom: 0;
          .custom-attr {
            display: flex;
            background: transparent;
            padding: 0 10px;
            span {
              display: block;
              width: 40%;
              text-align: left;
              height: 30px;
              line-height: 30px;
              color: #fff;
              font-size: 14px;
              box-sizing: border-box;
            }
            p {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              width: 20%;
              box-sizing: border-box;
              color: #fff;
              .el-link.el-link--default {
                color: #fff;
              }
            }
          }
          .custom-attr-list {
            li {
              display: flex;
              cursor: pointer;
              align-items: center;
              padding: 0 10px;
              box-sizing: border-box;
              span {
                display: block;
                width: 40%;
                text-align: left;
                height: 36px;
                line-height: 36px;
                color: rgba(255, 255, 255, 0.65);
              }
              .el-link.el-link--default {
                margin-left: 8px;
                color: #fff;
              }
              &:hover {
                background: rgba(255, 255, 255, 0.04);
                span {
                  color: #fff;
                }
              }
            }
          }
          .no-custom-attr {
            color: #ccc;
            margin: 10px 0;
          }
          .normal-attr {
            li {
              display: flex;
              justify-content: space-between;
              span {
                width: 50%;
                text-align: left;
                padding: 0 10px;
                box-sizing: border-box;
                color: #fff;
              }
              span:first-child {
                text-align: right;
                color: rgba(255, 255, 255, 0.65);
              }
            }
          }
        }
      }
    }
    .tab1,
    .tab2,
    .tab3  {
      .el-tree {
        background: transparent;
        .el-tree-node__content {
          color: rgba(255, 255, 255, 0.85);
          height: auto;
          padding: 5px;
        }
        .custom-tree-node2 {
          span {
            margin-left: 5px;
          }
        }
        .custom-tree-node {
          width: 100%;
          display: flex;
          justify-content: space-between;

          span {
            .el-button {
              padding: 0;
              padding-right: 10px;
            }
          }
          span:nth-child(2) {
            width: 50%;
            display: inline-block;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/attrs.vue